/**
 * Parsea una variable de entorno a número con fallback seguro.
 * - Si no existe, no es numérica o es <= 0 → usa fallback
 */
export function parseEnvNumber(value: string | undefined, fallback: number): number {
  const n = Number(value)

  return Number.isFinite(n) && n > 0 ? n : fallback
}
